import { render, staticRenderFns } from "./Education.vue?vue&type=template&id=3a74fcb4&scoped=true&"
import script from "./Education.vue?vue&type=script&lang=ts&"
export * from "./Education.vue?vue&type=script&lang=ts&"
import style0 from "./Education.vue?vue&type=style&index=0&id=3a74fcb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a74fcb4",
  null
  
)

export default component.exports